import React, { useState } from 'react';
import { FaFilePdf, FaChevronRight,FaEnvelope } from 'react-icons/fa';

import Header from './Header';
import Footer from './Footer';
import '../styles/PressureVacuumSensor.css';
// import QuoteModal from './QuoteModal'; // Adjust path

import PressureVacuumSensorMain from '../assets/PressureVacuumSensorMain.png'
import PressureVacuumSensor1 from '../assets/PressureVacuumSensor1.png'
import PressureVacuumSensor2 from '../assets/PressureVacuumSensor2.png'
import PressureVacuumSensor3 from '../assets/PressureVacuumSensor3.png'
import PressureVacuumSensor4 from '../assets/PressureVacuumSensor4.png'
import PressureVacuumSensor5 from '../assets/PressureVacuumSensor5.jpg'
import PressureVacuumSensor6 from '../assets/PressureIntelligent.png'
import PressureVacuumSensor7 from '../assets/PressureVacuumSensor7.png'


import PressureVacuumSensorpdfMain from '../assets/Fu-Tech Automation_Pressure_Temperature.pdf'
import PressureVacuumSensorpdf1 from '../assets/Fu-tek_Smart Pressure Switch.pdf'
import PressureVacuumSensorpdf2 from '../assets/Pressure_Transmitter.pdf'
import PressureVacuumSensorpdf3 from '../assets/Flush Pressure Transmitter.pdf'
import PressureVacuumSensorpdf4 from '../assets/Flush-Diaphragm-Pressure-Sensor-Updated.pdf'
import PressureVacuumSensorpdf5 from '../assets/Intelligent Differential Pressure Transmitter_FCM3051-W-DP.pdf'
import PressureVacuumSensorpdf6 from '../assets/Digital Intelligentr Pressure Switch.pdf'
import PressureVacuumSensorpdf7 from '../assets/Fu-tek_Melt Pressure Transmitter.pdf'
import WhatsAppModal from './WhatsAppModal';

export default function PressureVacuumSensor() {
  const [activeTab, setActiveTab] = useState('switch');
  // const [showModal, setShowModal] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);


  return (
    <div className="PressureVacuumSensor-wrapper">
      <Header />

      {/* Hero Section */}
      <div className="hero-banner20">
        <div className="hero-banner20-content">
          <h1>PRESSURE SENSORS / VACUUM SENSORS</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Pressure sensors / Vacuum sensors</span>
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <section className="sensor-main-content">
        <div className="sensor-description-block">
          <img src={PressureVacuumSensorMain} alt="Pressure Sensor Intro" />
          <div>
            <h2>Pressure sensors / Vacuum sensors</h2>
            <ul>
              <li>Sensors and transmitters with integrated evaluation</li>
              <li>Specially for the use in hygienic applications</li>
              <li>Excellent overload protection and long-term stability</li>
              <li>Measuring ranges of -1…..1000 bar</li>
              <li>Variable process connection using adapters</li>
            </ul>
            <div className="sensor-buttons">
              <a href={PressureVacuumSensorpdfMain}  target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>
              </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
                  {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="tab-headers">
          <button className={activeTab === 'switch' ? 'active' : ''} onClick={() => setActiveTab('switch')}>Switch</button>
          <button className={activeTab === 'transmitter' ? 'active' : ''} onClick={() => setActiveTab('transmitter')}>Pressure Transmitter</button>
          <button className={activeTab === 'flush' ? 'active' : ''} onClick={() => setActiveTab('flush')}>Flush Diaphragm</button>
          <button className={activeTab === 'differential' ? 'active' : ''} onClick={() => setActiveTab('differential')}>Differential PT</button>
          <button className={activeTab === 'intelligent' ? 'active' : ''} onClick={() => setActiveTab('intelligent')}>Intelligent Pressure Sensor</button>
          <button className={activeTab === 'melt' ? 'active' : ''} onClick={() => setActiveTab('melt')}>Melt Pressure Transducer</button>
        </div>

        {/* Tab Content */}
        <div className="PressureSensor-tab-content">
{activeTab === 'switch' && (
  <div className="PressureVacuumSensor-card-table">
    <div className="sensor-left">
      <div className="sensor-feature-card">
        <img src={PressureVacuumSensor1} alt="FPK103 Smart Pressure Switch" />
        <h3>FPK103 Smart Pressure Switch</h3>
        <a href={PressureVacuumSensorpdf1} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>
    <div className="sensor-right">
      <table className="switch-spec-table">
        <tbody>
          <tr><td>Media</td><td>Liquid and gaseous</td></tr>
          <tr><td>Connection</td><td>G 1/4 external / M5 internal</td></tr>
          <tr><td>Output</td><td>2x normally closed / open</td></tr>
          <tr><td>Operating Voltage</td><td>9.6 – 32V DC</td></tr>
          <tr><td>Electrical Design</td><td>DC, PNP/NPN</td></tr>
          <tr><td>Protection</td><td>IP65</td></tr>
          <tr><td>Temperature Range</td><td>-40°C to 80°C</td></tr>
          <tr><td>Probe Material</td><td>SS316L</td></tr>
          <tr>
            <td>Accuracy / deviation<br /><small>(in % of the span)</small></td>
            <td>
              Switch point accuracy: &lt; ± 2.5<br />
              Deviation of characteristics: &lt; ± 1.5 (BFSL)<br />
              &lt; ± 2.5 (LS)<br />
              Repeatability: &lt; ± 0.5
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)}


{activeTab === 'transmitter' && (
  <div className="PressureVacuumSensor-card-table">
    {/* Left Side Card */}
    <div className="sensor-feature-card">
      <img src={PressureVacuumSensor2} alt="FPM 220 Pressure Transmitter" />
      <h3>FPM 220 Pressure Transmitter</h3>
      <a href={PressureVacuumSensorpdf2} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn"><FaFilePdf />Download</button>
      </a>
    </div>

    {/* Right Side Table */}
    <div className="sensor-right">
      <table className="switch-spec-table">
        <tbody>
          <tr><td>Pressure Reference</td><td>Gauge, Absolute, Sealed Gauge</td></tr>
          <tr><td>Measuring Ranges</td><td>–100kPa…0 ~ 10kPa… , -1 ~ 1000 Bar</td></tr>
          <tr><td>Output Signal</td><td>4~20mA, 0.5 ~ 4.5V, 1 ~ 5V, 0 ~ 5V, 0 ~ 10V</td></tr>
          <tr><td>Supply Voltage</td><td>24VDC, 12VDC, 5VDC</td></tr>
          <tr><td>Accuracy</td><td>0.5%FS</td></tr>
          <tr><td>Operating Temperature</td><td>–40°C ~ 125°C</td></tr>
          <tr><td>Temperature Drift</td><td>1.5%FS (–20°C ~ 85°C)</td></tr>
          <tr><td>Housing</td><td>SS304</td></tr>
          <tr><td>Sensor Material</td><td>SS316L</td></tr>
          <tr><td>Electrical Connection</td><td>Hirschmann, Cable outlet, M12 Connector</td></tr>
          <tr><td>Protection</td><td>IP65</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}


{activeTab === 'flush' && (
  <>
    {/* Card 1: FPM350 Flush Pressure Transmitter */}
    <div className="PressureVacuumSensor-card-table">
      <div className="sensor-feature-card">
        <img src={PressureVacuumSensor3} alt="FCM350" />
        <h3>FPM350<br />Flush Pressure Transmitter</h3>
        <a href={PressureVacuumSensorpdf3} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>

      <div className="sensor-right">
        <table className="switch-spec-table">
          <tbody>
            <tr><td>Measuring Media</td><td>Liquids, gases, vapours, hygienic applications</td></tr>
            <tr><td>Measurement Type</td><td>Gauge and absolute pressure</td></tr>
            <tr><td>Output</td><td>4～20mA + HART, RS485, FF Fieldbus</td></tr>
            <tr><td>Measurement Range</td><td>-0.06 ~ 400 Bar</td></tr>
            <tr><td>Reference Accuracy</td><td>±0.05%, ±0.075%, ±0.1%</td></tr>
            <tr><td>Ambient Temperature</td><td>-40～+85℃; -20～+70℃ (with LCD)</td></tr>
            <tr><td>Supply Voltage</td><td>12～33VDC</td></tr>
            <tr><td>Material</td><td>SS304, 316L, Hastelloy, Monel (optional)</td></tr>
            <tr><td>Electrical Connection</td><td>M20x1.5 / NPT1/2 female thread; optional metal ex-proof</td></tr>
          </tbody>
        </table>
      </div>
    </div>

    {/* Card 2: FPM330 Flush Pressure Transmitter */}
    <div className="PressureVacuumSensor-card-table">
      <div className="sensor-feature-card">
        <img src={PressureVacuumSensor4} alt="FPM330" />
        <h3>FPM330<br />Flush Pressure Transmitter</h3>
        <a href={PressureVacuumSensorpdf4} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>

      <div className="sensor-right">
<table className="switch-spec-table">
  <tbody>
    <tr><td>Pressure Range</td><td>0 - 100 Bar</td></tr>
    <tr><td>Pressure Reference</td><td>Gauge pressure, absolute pressure, sealed gauge pressure</td></tr>
    <tr><td>Supply & Output</td><td>4~20mA (12~30VDC), 0~5V, 1~5V, 0.5~4.5V, 0~10V (12~24VDC)</td></tr>
    <tr><td>Accuracy</td><td>±0.5%FS</td></tr>
    <tr><td>Hysteresis & Repeatability</td><td>0.1%FS</td></tr>
    <tr><td>Temperature Drift</td><td>1.5%FS (@ -20℃ ~ 85℃)</td></tr>
    <tr><td>Response Time</td><td>&lt;1ms (up to 90%FS)</td></tr>
    <tr><td>Service Life</td><td>&gt;10×10⁶ pressure cycles</td></tr>
    <tr><td>Operating Temperature</td><td>-20℃ ~ 85℃</td></tr>
    <tr><td>Storage Temperature</td><td>-40℃ ~ 85℃</td></tr>
    <tr><td>Medium Temperature</td><td>-40℃ ~ 85℃ (without cooling fans), -40℃ ~ 150℃ (with 3 cooling fans), -40℃ ~ 250℃ (with 5 cooling fans)</td></tr>
    <tr><td>Insulation Resistance</td><td>&gt;100MΩ @ 250VDC</td></tr>
    <tr>
      <td>Vibration Resistance</td>
      <td>
        Sine curve: 20g, 25Hz–2kHz – IEC 60068-2-6;<br />
        Random: 7.5grms, 5Hz–1kHz – IEC 60068-2-64
      </td>
    </tr>
    <tr><td>Protection</td><td>IP65</td></tr>
    <tr><td>Medium Compatibility</td><td>All media compatible with stainless steel 316L</td></tr>
    <tr><td>Explosion Proof</td><td>Ex ia II CT6</td></tr>
  </tbody>
</table>

      </div>
    </div>
  </>
)}


{activeTab === 'differential' && (
  <div className="PressureVacuumSensor-card-table">
    {/* Left Side Card */}
    <div className="sensor-feature-card">
      <img src={PressureVacuumSensor5} alt="Differential PT" />
      <h3>FCM3051<br />Intelligent Differential Pressure Transmitter</h3>
      <a href={PressureVacuumSensorpdf5} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn"><FaFilePdf />Download</button>
      </a>
    </div>

    {/* Right Side Table */}
    <div className="sensor-right">
      <table className="switch-spec-table">
        <tbody>
          <tr><td>Pressure Range</td><td>0.01 ~ 30 Bar</td></tr>
          <tr><td>Supply Voltage</td><td>12VDC～32VDC (24V recommended)</td></tr>
          <tr><td>Output</td><td>4～20mA + HART® protocol</td></tr>
          <tr><td>Accuracy</td><td>
            ±1kPa: ±0.2%FS<br />
            ±6kPa: ±0.1%FS<br />
            Other standard ranges: ±0.075%FS (25±5℃)
          </td></tr>
          <tr><td>Ambient Temp.</td><td>-30℃～80℃<br />With LCD: -30℃～70℃</td></tr>
          <tr><td>Medium Temp.</td><td>-40℃～125℃</td></tr>
          <tr><td>Protection Grade</td><td>IP67</td></tr>
          <tr><td>Explosion-Proof Grade</td><td>Exd IIC T6 Gb</td></tr>
          <tr><td>Diaphragm Material</td><td>316L Stainless Steel</td></tr>
          <tr><td>Housing Material</td><td>Die-cast Aluminum Alloy (epoxy coating)</td></tr>
          <tr><td>Electrical Connection</td><td>M20×1.5 (F), NPT1/2 (F)</td></tr>
          <tr><td>Process Connection</td><td>
            M20×1.5 with welded pipe, 304 tri-valve<br />
            Optional: G1/4, NPT1/4, NPT1/2, Tri-valve in 304/316
          </td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}



{activeTab === 'intelligent' && (
  <div className="PressureVacuumSensor-card-table">
    {/* Left Side Card */}
    <div className="sensor-feature-card">
      <img src={PressureVacuumSensor6} alt="FPM710 Intelligent Pressure Switch" />
      <h3>FPM710<br />Intelligent Pressure Switch</h3>
      <a href={PressureVacuumSensorpdf6} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn"><FaFilePdf />Download</button>
      </a>
    </div>

    {/* Right Side Table */}
    <div className="sensor-right">
      <table className="switch-spec-table">
        <tbody>
          <tr><td>Pressure Range</td><td>-1 to 1 / 10 / 25 / 100 / 250 / 400 Bar</td></tr>
          <tr><td>Overload Capability</td><td>150～300%FS</td></tr>
          <tr><td>Accuracy</td><td>±0.5%FS</td></tr>
          <tr><td>Power Supply</td><td>12～30V (24V recommended)</td></tr>
          <tr><td>Display Mode</td><td>OLED, 4-digit</td></tr>
          <tr><td>Output Mode</td><td>2x switch outputs (NPN/PNP) + 4~20mA</td></tr>
          <tr><td>Load Capacity</td><td>≤24V, 1.2A</td></tr>
          <tr><td>Power Consumption</td><td>≤15mA</td></tr>
          <tr><td>Operating Temperature</td><td>-25℃～80℃</td></tr>
          <tr><td>Storage Temperature</td><td>-40℃～100℃</td></tr>
          <tr><td>Response Time</td><td>≤20ms</td></tr>
          <tr><td>Insulation</td><td>100MΩ / 250VDC</td></tr>
          <tr><td>Housing Material</td><td>SS304</td></tr>
          <tr><td>Medium Compatibility</td><td>Diaphragm 316L, Pressure port 304</td></tr>
          <tr><td>Process Connection</td><td>1/4" BSP</td></tr>
          <tr><td>Electrical Connection</td><td>M12</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}


{activeTab === 'melt' && (
    <div className="PressureVacuumSensor-card-table">
    {/* Left Side Card */}
    <div className="sensor-feature-card">
      <img src={PressureVacuumSensor7} alt="Melt Transducer" />
      <h3>FCMPT Series<br />Melt Pressure Transducer</h3>
      <a href={PressureVacuumSensorpdf7} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn"><FaFilePdf />Download</button>
      </a>
    </div>
    <div className="sensor-right">
      <table className="switch-spec-table">
        <tbody>
          <tr><td>Input Voltage </td><td>24VDC (12～36VDC)</td></tr>
          <tr><td>Output</td><td>4～20mA, 0～10V, 0～5V</td></tr>
          <tr><td>Accuracy Grade</td><td>±1.0%F.S</td></tr>
          <tr><td>Pressure Range</td><td>100 ~ 1000 Bar</td></tr>
          <tr><td>Pressure Unit </td><td>MPa (default), psi, bar</td></tr>
          <tr><td>Electrical Environmental Temp </td><td>-20～85℃</td></tr>
          <tr><td>Diaphragm Temp</td><td>320℃</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}

        </div>
      </section>

      <Footer />
    </div>
  );
}
